(function($){

    // Main menu two columns
    $('#main-nav li.menu-item-has-children > ul').each( function(index){
        var numOfLinks = $(this).children('li').length;
        // If has more than 8 links, then add class.
        if (numOfLinks > 8) {
            $(this).addClass('is-two-columns');
        }
    });



    // Add arrow SVG to menu toggle in mobile menu.
    $('.mobile-menu-main .submenu-toggle').each(function(){
        $(this).html('<span class="submenu-toggle-text">Toggle menu</span><svg xmlns="http://www.w3.org/2000/svg" width="14.512" height="8.296" viewBox="0 0 14.512 8.296"><path d="M17.046,13.448,11.555,7.961A1.037,1.037,0,0,1,13.024,6.5l6.221,6.217a1.035,1.035,0,0,1,.03,1.43L13.028,20.4a1.037,1.037,0,1,1-1.469-1.464Z" transform="translate(20.705 -11.251) rotate(90)" fill="currentColor"/></svg>');
    });



    // Add .has-expanded class to parent LI when accordion menu is opened.
    $('.mobile-menu-main .submenu-toggle').on('click', function(){
        // Get state from button.
        var status = $(this).attr('aria-expanded');
        if (status == 'true') {
            $(this).parent('li').addClass('has-expanded');
        } else {
            $(this).parent('li').removeClass('has-expanded');
        }
    });



     // Move focus to mobile search input.
     // Can't get to work on iOS safari.
     $('.site-header__search-toggle').on('click', function() {
        // If the menu is currently closed
        if ( $(this).attr('aria-expanded') == 'false' ) {
            // Wait a bit before focusing, because focus doesn't work on hidden elements.
            setTimeout(function() {
                $('#mobile-search input[type=search]').focus();
            }, 200);
        }
    });


    // Close Mobile Menu if opening the Mobile Search.
    $('.site-header__search-toggle').on('click', function() {
        if ( $('.site-header__menu-toggle').attr('aria-expanded') == 'true' ) {
            $('.site-header__menu-toggle').trigger('click');
        }
    });
    // Close Mobile Search if opening the Mobile Menu.
    $('.site-header__menu-toggle').on('click', function() {
        if ( $('.site-header__search-toggle').attr('aria-expanded') == 'true' ) {
            $('.site-header__search-toggle').trigger('click');
        }
    });



    $('.tech-spot__carousel').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 500,
        pauseOnFocus: false,
        pauseOnHover: false,
        fade: false,
        cssEase: 'linear'
    });

    $('.hero--carousel, .home-carousel').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 500,
        pauseOnFocus: false,
        pauseOnHover: false,
        fade: true,
        cssEase: 'linear',
        adaptiveHeight: true
    });



    // Activate Fancybox on Gutenberg Gallery block when images are linked.
    if ($('.wp-block-gallery')) {

        $('.wp-block-image').click(function() {

            var galleryImages = $(this).parent().find('a');
            var gallery = [];

            galleryImages.each(function( index, galleryItem ) {

                var caption = $(this).parent().find('figcaption').html();

                gallery.push({
                    src : galleryItem.href,
                    opts : {
                        caption: caption
                    }
                })
            });

            $.fancybox.open( gallery, { loop: false }, $(this).index() );

            return false;
        });
    }

})(jQuery);